import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import API from '../../api';
import { pushEvent } from "../../utilities/analytics";
import { MYFAVORITES_LOADED_EVENT } from "../../constants/analyticEvents";
import { FavoritesState } from '../../constants/storeState';

const initialState = {
  favoriteList: [],
  userFavorites: [],
  state: FavoritesState.idle,
};

export const fetchFavoriteListData = createAsyncThunk(
  'fetchFavorites',
  async (favoriteIdsList, thunkAPI) => {
    if (!favoriteIdsList || favoriteIdsList?.length < 1) {

      thunkAPI.fulfillWithValue({ offers: [] });
    }
    const response = await API.fetchFavoriteList(favoriteIdsList);
    pushEvent(MYFAVORITES_LOADED_EVENT, response.data);

    return response.data;
  }
);

export const favoriteSlice = createSlice({
  name: 'favorite',
  initialState,
  reducers: {
    updateFavoritesList: (state, action) => {
      return {
        ...state,
        favoriteIdsList: action.payload,
        state: FavoritesState.favoriteIdsSet,
      };
    },
    setState: (state, action) => {
      state.state = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchFavoriteListData.pending, (state) => {
        state.state = FavoritesState.favoritesLoading;
      })
      .addCase(fetchFavoriteListData.fulfilled, (state, action) => {
        return {
          ...state,
          favoriteList: action.payload.offers,
          state: FavoritesState.favoritesLoaded,
        };
      })
      .addCase(fetchFavoriteListData.rejected, (state) => {
        return {
          ...state,
          state: FavoritesState.failed,
        };
      })
  }
});

export const {
  updateFavoritesList,
  setState,
} = favoriteSlice.actions;

export const selectFavorite = (state) => state.favorite;

export default favoriteSlice.reducer;
